import axios from 'axios';

// const API_BASE_URL = 'http://localhost:8088/api';
const API_BASE_URL = 'https://effnetwork.com/app/api';

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://clubnet.app/EFFN_Test/Backend';

export const baseUrl = API_BASE_URL + '/';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    // Check for member token first (from third-party API), then fallback to regular token
    const memberToken = localStorage.getItem('memberToken');
    const token = memberToken || localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor to handle token expiration
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - clear storage and redirect to login
      localStorage.removeItem('memberToken');
      localStorage.removeItem('token');

      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/member/login')) {
        window.location.href = '/member/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
